export default function (...args)
{
	return {
		regex: /^(\d{5})(\d{3})$/,
		filter: /[\-]/g,
		store_mask: '$1$2',
		display_mask: '$1-$2'
	};
}

